import React from "react";

/**
 * GlowField — text/email/password/number input with elegant focus glow.
 * Used across login, signup, and dashboard forms.
 */
export const GlowField = React.forwardRef(function GlowField(
  { label, hint, error, dark = false, className = "", as = "input", children, testid, ...inputProps },
  ref
) {
  const base = "w-full bg-transparent text-sm px-4 py-2.5 outline-none transition-colors";
  const ringDark = "border border-white/10 text-white placeholder:text-neutral-500 focus:border-[#FFD600] focus:shadow-[0_0_0_3px_rgba(255,214,0,0.18),0_0_24px_rgba(255,214,0,0.18)] bg-[#10141C]";
  const ringLight = "border border-neutral-300 text-[#0A0C10] placeholder:text-neutral-400 focus:border-[#002FA7] focus:shadow-[0_0_0_3px_rgba(0,47,167,0.14),0_0_18px_rgba(0,47,167,0.12)] bg-white";

  const Comp = as;
  return (
    <label className={`block ${className}`}>
      {label && (
        <div className={`mb-1.5 text-[11px] font-mono uppercase tracking-[0.18em] ${dark ? "text-neutral-400" : "text-neutral-500"}`}>{label}</div>
      )}
      {as === "select" ? (
        <div className={`${base} ${dark ? ringDark : ringLight}`}>
          {children}
        </div>
      ) : (
        <Comp ref={ref} data-testid={testid} {...inputProps} className={`${base} ${dark ? ringDark : ringLight}`} />
      )}
      {hint && <div className={`mt-1 text-xs ${dark ? "text-neutral-500" : "text-neutral-500"}`}>{hint}</div>}
      {error && <div className="mt-1 text-xs text-red-500">{error}</div>}
    </label>
  );
});
